<template>
  <div class="commoditydetail">
    <div class="container">
      <div class="row commodityleft">
        <!-- 左侧图片部分 -->
        <div class="col-md-6 col-sm-6">
          <div class="row" style="margin-right:-30px;margin-left:-30px;">
            <!-- 左侧图片媒体库展示 -->
            <div
              class="d-sm-block d-none"
              v-if="gallery_show_config=='default'"
              style="width:100%;"
            >
              <!-- 左侧大图部分 -->
              <div class="col-12 bigphoto">
                <!-- <img :src="bigimg" @error.once="imageFailure" alt /> -->
                <img
                  :data-srcset="bigimg"
                  @load="loadedOn=true"
                  data-sizes="auto"
                  @error.once="imageFailure"
                  class="lazyload"
                  ref="bigimg"
                  alt
                />
                <!-- srcset配置 -->
              </div>
              <!--左侧小图部分  -->
              <div class="row smallimg" v-if="smallimg.length>1">
                <div
                  class="col-md-3 col-4"
                  v-for="item in smallimg"
                  :key="'gallery'+item.ID"
                  @click="selectcommodityimg"
                  :class="featureImageId==item.ID?'active':''"
                >
                  <img
                    :data-src="item.thumbnail?item.thumbnail:defaultImage"
                    :data-big="item.srcset"
                    @error.once="imageFailure"
                    class="lazyload"
                    alt
                  />
                  <!-- <img
                    :data-src="item.thumbnail?item.thumbnail:defaultImage"
                    :data-big="item.srcset"
                    @error.once="imageFailure"
                    class="lazyload"
                    alt
                  />-->
                  <!-- srcset配置 -->
                </div>
              </div>
            </div>
            <!-- 左侧图片平铺展示 -->
            <div class="d-sm-block d-none col-12 bigphoto" v-else>
              <!-- <img
                v-for="item in smallimg"
                :key="'flatgallery'+item.ID"
                :src="item.url"
                @error.once="imageFailure"
                style="margin-bottom:50px;"
                class="lazyload"
                alt
              />-->
              <img
                :data-srcset="item.srcset"
                data-sizes="auto"
                v-for="item in smallimg"
                :key="'flatgallery'+item.ID"
                @error.once="imageFailure"
                style="margin-bottom:50px;"
                class="lazyload"
                alt
              />
              <!-- srcset配置 -->
            </div>
            <!-- 小屏轮播图 -->
            <v-product-swiper :gallery="smallimg"></v-product-swiper>
          </div>
        </div>
        <!--右侧商品详情  -->
        <div class="col-md-6 col-sm-6 commodityright">
          <div class="deploy">
            <div class="row justify-content-center">
              <v-countdown
                v-if="count_down&&count_down_show"
                :count_down="count_down"
                position="detail"
              ></v-countdown>
              <h2
                class="col-md-10 commodityname title_font"
                style="white-space:pre-wrap;"
              >{{product.post_title}}</h2>
              <div class="col-md-10 commoditypricetype">
                <v-selectprice :price="price" fontSize="18" :regular_price_num="regular_price"></v-selectprice>
                <!-- <div class="tax">Tax included.</div> -->
              </div>
            </div>
            <v-line></v-line>
            <!-- 右侧商品详情变种 -->
            <template v-if="product.variants.length>1">
              <div
                class="row justify-content-center commodityattribute"
                v-for="(item,index) in variant_attrs"
                :key="item.name+index"
              >
                <div class="col-md-10">
                  <p>{{item.name}}</p>
                  <div v-if="variants_show_config=='label'">
                    <!-- 判断variant[index].value是否等于这个值是的话加active类名 -->
                    <div
                      v-for="subitem in item.value"
                      :key="item.name+index+subitem"
                      style="display:inline-block"
                    >
                      <input
                        type="radio"
                        :name="variant[index].name"
                        v-model="variant[index].value"
                        :value="subitem"
                        @click="changevariant(index,subitem)"
                        :id="item.name+index+subitem"
                      />
                      <label
                        :class=" variant[index].value==subitem?'active':'' "
                        :for="item.name+index+subitem"
                      >
                        <span>{{subitem}}</span>
                      </label>
                    </div>
                  </div>
                  <div v-else>
                    <select v-model="variant[index].value" @change="changevariant">
                      <option
                        v-for="subitem in item.value"
                        :key="subitem"
                        :value="subitem"
                      >{{subitem}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </template>
            <!-- 右侧商品详情数量 -->
            <div class="row addcart justify-content-center">
              <form @submit.prevent="addcart">
                <div class="col-md-12 commoditynum">
                  {{$t('detail.quantity')}}
                  <!-- <input
                    type="number"
                    min="1"
                    max="100000"
                    value="1"
                    v-model="addproduct.quantity"
                  />-->
                  <el-input-number v-model="addproduct.quantity" :step="1" step-strictly :min="1" :max="100000"></el-input-number>
                </div>
                <div class="col-md-10 offset-md-1">
                  <el-button
                    class="gocart secondary_title"
                    :class="paypal_product_position=='buynow'?'minor_button':'main_button'"
                    type="button"
                    native-type="submit"
                    :loading="loading"
                    v-if="stock"
                  >{{$t('detail.add_to_cart')}}</el-button>
                  <el-button
                    v-else
                    class="gocart soldout"
                    type="button"
                    disabled
                  >{{$t('detail.sold_out')}}</el-button>
                  <!-- <v-paypal :addproduct="addproduct" v-if="stock"></v-paypal> -->
                  <el-button
                    class="buynow main_button"
                    v-if="paypal_product_position=='buynow'"
                    :loading="loading"
                    @click="!loading&&addcart('buynow')"
                    v-show="stock"
                  >{{$t('detail.but_it_now')}}</el-button>
                  <div
                    v-if="paypal_product_position=='yes'"
                    id="paypal-button"
                    v-show="stock"
                    :addproduct="JSON.stringify(addproduct)"
                    :pixel="pixel"
                  ></div>
                  <!-- <div id="paypal-button-container"></div> -->
                  <!-- group_products_position=='above'&& -->
                  <v-bulk-coupon
                    v-if="has_bulk_coupon"
                    :cart_type="cart_type"
                    :bulk_coupon="bulk_coupon"
                    :product_id="addproduct.product_id"
                    :variant_id="addproduct.variant_id"
                    theme="Brooklyn"
                    :product="product"
                  ></v-bulk-coupon>
                  <v-groupedproduct
                    v-if="add_group_products&&(group_products_position=='button below'||group_products_position=='above')&&group_product&&group_product.length>0"
                    :price="price"
                    :group_product="group_product"
                    :group_product_all="group_product_all"
                    :regular_price="regular_price"
                    :stock="stock"
                    :loading="loading"
                    :getSymbolFromCurrency="getSymbolFromCurrency"
                    :smallimg="smallimg"
                    :variant_attrs="variant_attrs"
                    :variant="variant"
                    :product="product"
                    :cart_type="cart_type"
                    :ga="ga"
                    theme="Brooklyn"
                    :group_products_title="group_products_title"
                    group_products_position="button below"
                    :show_currency_selector="true"
                  ></v-groupedproduct>
                </div>
              </form>
            </div>
          </div>
          <!-- 右侧商品详情公共部分 -->
          <div class="row">
            <div class="col-md-10 offset-md-1 recommend">
              <div v-html="product.post_content" class="post_content text_font"></div>
              <v-groupedproduct
                v-if="add_group_products&&group_products_position=='right'&&group_product&&group_product.length>0"
                :price="price"
                :group_product="group_product"
                :group_product_all="group_product_all"
                :regular_price="regular_price"
                :stock="stock"
                :loading="loading"
                :getSymbolFromCurrency="getSymbolFromCurrency"
                :smallimg="smallimg"
                :variant_attrs="variant_attrs"
                :variant="variant"
                :product="product"
                :cart_type="cart_type"
                :ga="ga"
                theme="Brooklyn"
                :group_products_title="group_products_title"
                group_products_position="right"
                :show_currency_selector="true"
              ></v-groupedproduct>
              <div class="social-sharing">
                <social-sharing
                  :title="product.post_title"
                  :description="product.post_title"
                  :media="smallimg[0].url"
                  inline-template
                  @open="share_event"
                  v-if="enable_facebook"
                >
                  <network network="facebook">
                    <i class="iconfont icon-facebook"></i> Share
                  </network>
                </social-sharing>
                <social-sharing
                  :title="product.post_title"
                  :description="product.post_title"
                  :media="smallimg[0].url"
                  inline-template
                  @open="share_event"
                  v-if="enable_twitter"
                >
                  <network network="twitter">
                    <i class="iconfont icon-twitter"></i> Tweet
                  </network>
                </social-sharing>
                <social-sharing
                  :title="product.post_title"
                  :description="product.post_title"
                  :media="smallimg[0].url"
                  inline-template
                  @open="share_event"
                  v-if="enabel_pinterest"
                >
                  <network network="pinterest">
                    <i class="iconfont icon-pinterest"></i> Pin it
                  </network>
                </social-sharing>
              </div>
            </div>
          </div>
        </div>
        <div v-if="collectionsid!=slug" class="col-12 text-center backcollection">
          <a
            :href="'/collections/'+collectionsid"
            @click.prevent="backcollection"
          >← {{$t('detail.back_to')}} {{ name.toString().toUpperCase()}}</a>
        </div>
      </div>
      <!-- group_products_position=='below'&& -->
      <!-- 组合商品 -->
      <v-groupedproduct
        v-if="add_group_products&&group_products_position=='below'&&group_product&&group_product.length>0"
        :price="price"
        :group_product="group_product"
        :group_product_all="group_product_all"
        :regular_price="regular_price"
        :stock="stock"
        :loading="loading"
        :getSymbolFromCurrency="getSymbolFromCurrency"
        :smallimg="smallimg"
        :variant_attrs="variant_attrs"
        :variant="variant"
        :product="product"
        :cart_type="cart_type"
        :ga="ga"
        theme="Brooklyn"
        :group_products_title="group_products_title"
        group_products_position="below"
        :show_currency_selector="true"
      ></v-groupedproduct>
    </div>
    <!-- 推荐商品 -->
    <v-guess-like
      v-if="recommended_product&&show_recommended"
      :show_currency_selector="true"
      :recommended_product="recommended_product"
      :cart_type="cart_type"
      :pixel="pixel"
      :ga="ga"
      :product_id="product.ID"
      theme="Brooklyn"
    ></v-guess-like>
    <!-- 商品评论 -->
    <v-comments
      v-if="comment"
      :comment="comment"
      :review_count="product.review_count"
      :average_rating="product.average_rating"
      :rating_count="product.rating_count"
      :comments="product.comments"
      :product_id="product.ID"
    ></v-comments>
    <div class="container">
      <v-groupedproduct
        v-if="add_group_products && group_products_position=='foot' && group_product&&group_product.length>0"
        :price="price"
        :group_product="group_product"
        :group_product_all="group_product_all"
        :regular_price="regular_price"
        :stock="stock"
        :loading="loading"
        :getSymbolFromCurrency="getSymbolFromCurrency"
        :smallimg="smallimg"
        :variant_attrs="variant_attrs"
        :variant="variant"
        :product="product"
        :cart_type="cart_type"
        :ga="ga"
        theme="Brooklyn"
        :group_products_title="group_products_title"
        group_products_position="foot"
        :show_currency_selector="true"
      ></v-groupedproduct>
    </div>
    <!-- 快捷加购 -->
    <v-quickaddcart
      v-if="quick_add_cart"
      type="default"
      :quick_add_cart="quick_add_cart"
      :variant_new="variant_new"
      :product="product"
      :price="price"
      :regular_price="regular_price"
      :stock="stock"
      :loading="loading"
      :variant_attrs="variant_attrs"
      :variant="variant"
      :addproduct="addproduct"
      @fatherMethod="addcart"
      :show_currency_selector="true"
    ></v-quickaddcart>
  </div>
</template>

<script>
import API from "../../API.js";
import defaultImage from "../../../../public/images/no-image.gif";
import getSymbolFromCurrency from "currency-symbol-map";
import vGroupedproduct from "../view/groupedproduct/index";
import vGuessLike from "../view/guesslike/guesslike";
import vQuickaddcart from "../view/quickaddcart/index";
import vBulkCoupon from "../common/bulkcoupon";
import vProductSwiper from "../common/productSwiper";
export default {
  props: [
    "group_product",
    "group_product_all",
    "name",
    "collectionsid",
    "slug",
    "variants_show_config",
    "gallery_show_config",
    "product",
    "variant_attrs",
    "status",
    "pixel",
    "ga",
    "enable_facebook",
    "enable_twitter",
    "enabel_pinterest",
    "cart_type",
    "count_down",
    "quick_add_cart",
    "comment",
    "add_group_products",
    "group_products_title",
    "group_products_position",
    "recommended_product",
    "paypal_product_position",
    "bulk_coupon"
  ],
  data() {
    return {
      notNextTick: true,
      swiperOption: {
        autoHeight: true, //enable auto height
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        loop: true
      },
      getSymbolFromCurrency: "",
      featureImageId: "", //变种商品图片ID
      regular_price: "",
      price: this.product.price,
      defaultImage,
      bigimg: "",
      smallimg: [],
      addproduct: {
        quantity: "1",
        product_id: ""
      },
      loading: false,
      variant: [], //根据变种属性name创建一个数组variant，value为变种属性的第一个值
      stock: false,
      variant_new: "",
      quick: false, //快速结账开关
      count_down_show: false, //促销倒计时开关
      show_recommended: false,
      loadedOn: false,
      variant_id: null,
      has_bulk_coupon: false
    };
  },
  methods: {
    handleScroll() {
      // console.log(window.pageYOffset)
      if (window.pageYOffset > 760) {
        this.$(".quickPurchased").slideDown(300);
      } else {
        this.$(".quickPurchased").slideUp(300);
      }
      // console.log('quick',this.quick);
    },
    async share_event(e) {
      try {
        let res = await this.$axios.post(API.statis_event, {
          name: "shares." + e,
          parameters: { url: window.location.href }
        });
        console.log(res);
      } catch (error) {
        console.log(error.response);
      }
    },
    backcollection() {
      console.log("huitui");
      window.history.back();
    },
    // 图片加载失败时触发一次
    imageFailure(e) {
      console.log("imagefail");
      e.target.src = this.defaultImage;
    },
    gotvariant(item) {
      if (
        item.buy_able
        // item.manage_stock === "no" ||
        // item.backorders === "yes" ||
        // (item.manage_stock === "yes" && item.stock > 0)
      ) {
        this.stock = true;
      } else {
        this.stock = false;
      }
      window.history.replaceState(
        {},
        "",
        this.replaceSearch("variant", item.ID)
      );
      //这个变种商品如果有图片则把这张图赋给bigimg,并且修改featureImageId来给gallery添加active
      if (item.feature_image) {
        this.bigimg = item.feature_image.srcset;
        if (this.featureImageId != item.feature_image.ID) {
          this.$(".smallimg div").removeClass("active");
        }
        // this.bigimg = item.feature_image.srcset;//srcset配置
        this.featureImageId = item.feature_image.ID;
        this.$store.dispatch("change_feature_image_id", item.feature_image.ID);
        //移动swiper图片的位置
        // this.product.gallery.forEach((subitem, subindex) => {
        //   if (subitem.ID == this.featureImageId) {
        //     this.swiper.slideTo(subindex + 1);
        //   }
        // });
        //移动平铺照片的首个
        if (this.gallery_show_config == "flat") {
          this.smallimg.some((flatitem, flatindex) => {
            if (flatitem.ID == this.featureImageId) {
              this.smallimg.unshift(this.smallimg.splice(flatindex, 1)[0]);
            }
          });
        }
      } else {
        this.$store.dispatch("change_feature_image_id", 0);
        this.featureImageId = 0;
      }
      this.variant_new = item;
      console.log("variant_new", this.variant_new);
      this.$store.dispatch("change_now_variant", this.variant_new);
      this.addproduct.variant_id = item.ID;
      this.price = item.price;
      //判断这个变种商品的regular_price存在吗,如果存在就regular_price且大于现价就显示原价,不存在就为0;
      this.regular_price =
        item.regular_price && item.regular_price - 0 > item.price - 0
          ? item.regular_price
          : false;
      return true;
    },
    // 当绑定于variant中的值改变后判断整个variant和变种商品中那个attrs相同来获取该变种商品的id
    changevariant(index, value) {
      console.log("changevariant", index, value);
      if (index != undefined && value != undefined) {
        this.variant[index].value = value;
      }
      // 如果只有一个index参数时候则代表有查询参数variant，此时根据variant_id获取变种商品，并改变变种规格。
      if (index != undefined && value == undefined) {
        let variant_res = this.product.variants.some(item => {
          if (item.ID == index) {
            this.variant.forEach(variant_item => {
              item.attrs.some(attrs_item => {
                if (variant_item.name == attrs_item.name) {
                  variant_item.value = attrs_item.value;
                  return true;
                }
              });
            });
            return this.gotvariant(item);
          }
        });
        // 如果判断出结果则终止这个函数。如果查询参数有误则继续函数，按默认的方式走；
        if (variant_res) {
          return;
        }
      }
      this.product.variants.some(item => {
        let res = item.attrs.every(subitem => {
          return this.variant.some(lowitem => {
            return (
              lowitem.name == subitem.name && lowitem.value == subitem.value
            );
          });
        });
        //判断出是哪个个变种商品了
        if (res) {
          return this.gotvariant(item);
        } else {
          this.stock = false;
        }
      });
      console.log("variant", this.variant);
    },
    selectcommodityimg(e) {
      this.$store.dispatch("change_feature_image_id", 0);
      this.featureImageId = 0;
      if (e.target.tagName == "IMG") {
        this.$(e.target)
          .parent()
          .addClass("active");
        this.$(e.target)
          .parent()
          .siblings()
          .removeClass("active");
        this.bigimg = e.target.dataset.big;
      } else {
        this.$(e.target)
          .siblings()
          .removeClass("active");
        this.$(e.target).addClass("active");
        this.bigimg = e.target.children[0].dataset.big;
      }
    },
    async addcart(buynow) {
      try {
        this.loading = true;
        this.addproduct.quantity = this.addproduct.quantity || 1;
        this.addproduct.quantity =
          this.addproduct.quantity > 100000 ? 100000 : this.addproduct.quantity;
        console.log("addproduct", this.addproduct);
        console.log("variant_new", this.variant_new);
        console.log(this.addproduct);
        if (buynow == "buynow") {
          this.addproduct.clear = true;
        } else {
          delete this.addproduct["clear"];
        }

        let res = await this.$axios.post(API.addcart, this.addproduct);
        this.$store.dispatch("change_news_cart", res.data);
        if (window.fbq) {
          let content_category = [];
          if (this.product.categories && this.product.categories.length) {
            this.product.categories.forEach(item => {
              content_category.push(item.name);
            });
          }
          window.fbq("track", "AddToCart", {
            content_type: "product_group",
            content_ids: [this.addproduct.product_id],
            value: this.variant_new.price,
            num_items: this.addproduct.quantity,
            content_name: this.variant_new.title,
            currency: res.data.currency,
            content_category
          });
        }
        if (window.gtag) {
          window.gtag("event", "add_to_cart");
        }
        if (buynow == "buynow") {
          this.cart_hash = this.getCookie("cart_hash");
          this.toCheckInfo(this.cart_hash);
          // window.open(
          //   `/checkouts/${this.cart_hash}?step=contact_information`,
          //   "_self"
          // );
        } else if (this.cart_type == "drawer") {
          this.loading = false;
          this.$store.dispatch("change_cart_type", true);
        } else {
          window.open("/cart", "_self");
        }
        setTimeout(() => {
          this.loading = false;
        }, 5000);
      } catch (error) {
        this.loading = false;
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          this.$message.error(Object.values(error.response.data.errors)[0][0]);
        } else {
          this.$message.error(error.response.data.message);
        }
      }
    }
  },
  beforeMount() {
    this.variant_id = this.getSearch("variant=");
    if (this.recommended_product) {
      console.log(this.recommended_product);
      this.show_recommended = !this.recommended_product.shieldProduct.includes(
        this.product.ID
      );
    }
    console.log("this.paypal_product_position", this.paypal_product_position);
    if (this.count_down) {
      this.count_down_show =
        this.count_down.detail.type == "all" ||
        this.count_down.detail.product_ids.includes(this.product.ID) ||
        this.count_down.detail.category_ids.some(item => {
          return this.product.categories.some(subitem => {
            return subitem.id == item;
          });
        });
    }
    console.log("count_down_show", this.count_down_show);
    this.getSymbolFromCurrency = getSymbolFromCurrency;
    this.variant_new = this.product;
    this.regular_price =
      this.product.regular_price &&
      this.product.regular_price - 0 > this.product.price - 0
        ? this.product.regular_price
        : false;
    this.addproduct.product_id = this.product.ID;
    // this.bigimg = this.product.feature_image
    //   ? this.product.feature_image.srcset
    //   : defaultImage;
    if (this.product.feature_image) {
      this.bigimg = this.product.feature_image.srcset;
      this.featureImageId = this.product.feature_image.ID;
    } else {
      this.bigimg = defaultImage;
    }
    // this.bigimg = this.product.feature_image
    //   ? this.product.feature_image.srcset
    //   : defaultImage;//srcset配置
    //如果相册没有图片的话
    if (!this.product.gallery.length) {
      console.log("gallery==0");
      //给轮播图添加一张图片
      this.smallimg.push({
        ID: "defaultImage",
        url: this.defaultImage,
        srcset: this.defaultImage
      });
    }
    // 将商品所有图片添加到左侧小图中
    this.smallimg.push(...this.product.gallery);
    // 若有变种属性则根据变种属性name创建一个数组variant，value为变种属性的第一个值，该数组同时可用与单选框绑定属性
    if (this.variant_attrs.length) {
      this.variant_attrs.forEach(item => {
        this.variant.push({
          name: item.name,
          value: item.value[0]
        });
      });
    } else {
      //判断有没有库存
      if (
        this.product.buy_able
        // this.product.manage_stock === "no" ||
        // this.product.backorders === "yes" ||
        // (this.product.manage_stock === "yes" && this.product.stock > 0)
      ) {
        this.stock = true;
      }
    }
    if (this.bulk_coupon && this.bulk_coupon.product_ids) {
      this.has_bulk_coupon =
        this.bulk_coupon.product_ids.length == 0 ? true : false;
      this.bulk_coupon.product_ids.some(item => {
        if (item == this.addproduct.product_id) {
          this.has_bulk_coupon = true;
          return true;
        }
      });
    }
  },
  mounted() {
    console.log("group_products_position", this.group_products_position);

    if (this.variant_attrs.length) {
      // 设置变种属性默认值后先获取一遍变种id
      this.changevariant(this.variant_id);
    }
    // if (this.quick_add_cart) {
    //   document.addEventListener("scroll", this.handleScroll, true);
    //   this.$(".commonfoot").css(
    //     "paddingBottom",
    //     this.$(".quickPurchased").innerHeight() + "px"
    //   );
    // }
    console.log(this.product);
    // console.log("smallimg", this.smallimg);
    // console.log("price", this.price);
    // console.log("asdfsadf", this.variant);
    // console.log("variant_attrs", this.variant_attrs);
    console.log("quick_add_cart", this.quick_add_cart);
    console.log("group_products_position", this.group_products_position);
  },
  watch: {
    variant: {
      handler(newName, oldName) {
        this.changevariant();
      },
      immediate: false,
      deep: true
    },
    bigimg(newV) {
      if (this.loadedOn) {
        this.$refs.bigimg.srcset = newV;
      }
    }
  },
  computed: {
    //获取swiper实例
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  components: {
    vBulkCoupon,
    vGroupedproduct,
    vGuessLike,
    vQuickaddcart,
    vProductSwiper
  }
};
</script>
<style lang='scss'>
.commoditydetail {
  margin-top: 80px;
  .container {
    .commodityleft {
      .backcollection {
        margin-top: 50px;
        a {
          text-decoration: none;
          color: #000;
          font-size: 14px;
        }
      }
      .bigphoto {
        text-align: center;

        img {
          max-width: 100%;
          max-height: 570px;
        }
      }
      .smallimg {
        div {
          width: 100%;
          margin-top: 10px;
          text-align: center;

          img {
            max-width: 100%;
            max-height: 112px;
            border: 2px solid rgba(0, 0, 0, 0);
            cursor: pointer;
          }
        }

        .active {
          img {
            border-color: black;
          }
        }
      }
    }

    .commodityright {
      div {
        .recommend {
          img,
          iframe,
          video {
            max-width: 100% !important;
          }
          pre {
            white-space: pre-wrap;
          }
        }
        .social-sharing {
          text-align: center;
          margin-top: 50px;
          span {
            margin-left: 10px;
            cursor: pointer;
            font-size: 14px;
            -webkit-tap-highlight-color: rgba(23, 178, 235, 0.3) !important;
          }
          span:hover {
            opacity: 0.7;
          }
        }
      }
      .deploy {
        text-align: center;
        .commodityname {
          font-size: 36px;
          margin-bottom: 15px;
        }

        .commoditypricetype {
          font-size: 18px;
          .regular_price {
            margin-right: 10px;
            font-size: 18px;
            text-decoration: line-through;
          }
          .tax {
            margin: 15px 0 0 0;
            font-weight: 400;
            font-size: 15px;
            color: #222323;
          }
        }

        .commodityattribute {
          margin-bottom: 13px;
          p {
            font-size: 15px;
            margin-bottom: 10px;
          }
          label {
            display: inline-block;
            font-family: "Open Sans", sans-serif;
            font-weight: 600;
            font-style: normal;
            letter-spacing: 0.1em;
            text-transform: uppercase;
            line-height: 1;
            padding: 9px 11px;
            margin: 3px 10px 7px 3px;
            font-size: 0.86667em;
            font-style: normal;
            background-color: #fff;
            border: 1px solid #fff;
            color: #222323;
            cursor: pointer;
          }
          input {
            // display: none;
            clip: rect(0, 0, 0, 0);
            overflow: hidden;
            position: absolute;
            height: 1px;
            width: 1px;
            &:focus + label,
            &:active + label {
              background-color: #f2f2f2;
            }
          }
          select {
            max-width: 100%;
            outline: none;
            font-size: 1.2em;
            border-color: transparent;
            color: #1c1d1d;
            padding: 8px 28px 8px 10px;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            background: #f6f6f6 url("../../../../public/images/downward1.png")
              no-repeat right 5px center;
            background-size: 10px;
            &:hover {
              outline: 1px solid #dddddd;
            }
          }

          .active {
            // background: #f2f2f2;
            border: 1px solid #222323;
          }
        }

        .addcart {
          margin-bottom: 40px;

          form {
            width: 100%;

            .commoditynum {
              font-size: 15px;
              .el-input-number {
                width: 100px !important;
                .el-input-number__decrease,
                .el-input-number__increase {
                  width: 29px !important;
                  background: unset !important;
                  i {
                    font-weight: 600 !important;
                  }
                  &:hover {
                    color: #606266 !important;
                  }
                }
                .el-input {
                  .el-input__inner {
                    font-size: 18px;
                    background-color: #f6f6f6 !important ;
                    padding: 5px 25px !important;
                    border: 0px solid #dcdfe6 !important;
                  }
                }
              }
              // input {
              //   width: 223px;
              //   height: 43px;
              //   padding: 8px 10px;
              //   border: none;
              //   background: #f6f6f6;
              //   margin-left: 10px;
              // }
            }
            .gocart {
              display: inline-block;
              width: 100%;
              height: 44px;
              margin: 20px 0 0px;
              padding: 12px 30px;
              background: #c90d0d;
              // background: rgb(201, 13, 13);
              color: #fff;
              border: 1px solid #c90d0d;
              border-radius: 0;
              &:hover {
                background: rgb(241, 34, 34);
              }
            }
            .buynow {
              width: 100%;
              background-color: #111112;
              color: #e6e6e7;
              text-align: center;
              font-size: 13px;
              font-family: "Oswald", sans-serif;
              height: 44px;
              letter-spacing: 1px;
              cursor: pointer;
              margin: 18px 0 0 0 !important;
              border-radius: 0;
              &:hover {
                opacity: 0.9;
              }
            }
            .soldout {
              background: #f6f6f6 !important;
              color: #717171 !important;
              border: none;
            }
            #paypal-button {
              margin-top: 15px;
            }
          }
        }
      }
    }

    // 组合商品
  }

  // .quickPurchased {
  //   width: 100%;
  //   // height: 70px;
  //   background: #fff;
  //   position: fixed;
  //   bottom: 0;
  //   left: 0;
  //   z-index: 999;
  //   box-shadow: 0 -2px 2px rgba(0, 0, 0, 0.08);
  //   .container {
  //     .sm_img {
  //       border: 1px solid #f6f6f6;
  //       width: 54px;
  //       height: 54px;
  //       margin-right: 10px;
  //     }
  //     .sm_describe {
  //       a {
  //         color: #1890ff;
  //         font-size: 16px;
  //         cursor: pointer;
  //         &:hover {
  //           text-decoration: underline;
  //         }
  //       }
  //       p {
  //         color: #666;
  //         font-size: 14px;
  //         margin: 0;
  //         span:not(:last-child) {
  //           &::after {
  //             content: "/";
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
}

@media screen and (max-width: 1200px) {
  .smallimg {
    img {
      max-height: 90px !important;
    }
  }
}

@media screen and (max-width: 992px) {
  .smallimg {
    img {
      max-height: 60px !important;
    }
  }
  // .sm_quickPurchased {
  //   height: 70px;
  //   .sm_quick_right {
  //     width: 100%;
  //     height: 100%;
  //     padding: 0;
  //     .sm_button {
  //       height: 70px !important;
  //       width: 110% !important;
  //       margin-left: -38px !important;
  //       margin-top: -8px !important;
  //     }
  //   }
  // }
}

@media screen and (max-width: 575px) {
  .commodityname {
    font-size: 30px !important;
    font-weight: normal !important;
  }
  .commoditydetail {
    margin-top: 0 !important;
    // .quickPurchased {
    //   .quick_right {
    //     width: 100vw !important;
    //     max-width: 100vw !important;
    //     .sm_button {
    //       height: 56px !important;
    //       width: 100vw !important;
    //       margin-left: 22px !important;
    //       margin-top: -8px !important;
    //       margin-bottom: -8px !important;
    //     }
    //   }
    // }
  }
}
</style>